<template>
  <b-code>
    <!-- button  v-if="folders.length === 0" -->
    <b-button
      id="toggle-btn"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-prevent-closing
      variant="outline-primary"
    >
      <feather-icon icon="FolderPlusIcon" />
      Criar Pastas
    </b-button>

    <!-- modal data -->
    <!-- <div class="mt-2">
      <div v-if="submittedNames.length === 0">

      </div>
      <b-list-group
        v-else
      >
        <b-list-group-item
          v-for="(data,index) in submittedNames"
          :key="index"
        >
          {{ data }}
        </b-list-group-item>
      </b-list-group>
    </div> -->

    <!-- modal -->
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Nova pasta"
      ok-title="Criar Pasta"
      cancel-title="Cancelar"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form
        ref="form"
        @submit.stop.prevent="CriarPasta"
      >
        <b-form-group
          :state="nameState"
          label="Nome da pasta"
          label-for="name-input"
          invalid-feedback="Esse campo é obrigatório"
        >
          <b-form-input
            id="name-input"
            v-model="pastaAws.folder_name"
            :state="nameState"
            placeholder="Digite o nome da pasta"
            required
          />
        </b-form-group>
      </form>
    </b-modal>

    <template #code>
      {{ codePrevent }}
    </template>
  </b-code>
</template>

<script>

import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BCardText, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import { codePrevent } from '@/views/App/Pastas/code copy'
import { FolderService } from '@/services/Folder'
import FoldersVue from './Folders.vue'

export default {
  name: 'Modal',
  components: {
    BCardCode,
    BButton,
    BFormGroup,
    BCardText,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,

  },
  directives: {
    'b-modal': VBModal,

    Ripple,
  },

  data() {
    return {
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3 || '/api/dkbucket',
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      userData: JSON.parse(localStorage.getItem('userData')),
      codePrevent,
      // folder: {
      //   folder_name: '',
      //   id_user: '',
      // },

      pastaAws: {
        folder_name: '',
      },

      nameState: null,
      folders: [],

    }
  },

  async created() {
    try {
      this.loading = true
      const response = await FolderService.getALLFolders()
      this.folders = response.data
      this.loading = false
      // console.log('folders');
      // console.log(this.folders)
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  mounted() {
    this.listar()
  },
  methods: {
    listar() {
      FolderService.getALLFolders().then(resposta => {
        this.folders = resposta.data
      }).catch(e => {
        console.log(e)
      })
    },
    // submitCreate: async function () {

    //   },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.name = valid
      return valid
    },
    resetModal() {
      this.pastaAws.folder_name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.CriarPasta()
    },
    async CriarPasta() {
      if (!this.pastaAws.folder_name || !this.pastaAws.folder_name.trim()) return

      try {
        // Tenta criar pasta no S3 (opcional — falha silenciosamente se S3 não configurado)
        let urlPasta = ''
        let keyName = ''
        try {
          const s3Res = await fetch(
            `${this.VUE_APP_HOST_API_AWS_S3}/create?caminho=UploadFolderVideos/${encodeURIComponent(this.pastaAws.folder_name)}/`,
            { method: 'POST' },
          )
          if (s3Res.ok) {
            const contentType = s3Res.headers.get('content-type') || ''
            if (contentType.includes('application/json')) {
              const s3Data = await s3Res.json()
              urlPasta = s3Data.fileUrl || ''
              keyName = s3Data.file_key || ''
            }
          }
        } catch (_s3Err) {
          // S3 não configurado — continua sem URL de bucket
        }

        // Cria a pasta no banco de dados (sempre, independente do S3)
        const result = await FolderService.createFolder({
          folder_name: this.pastaAws.folder_name.trim(),
          folder_backet_adress: urlPasta,
          folder_key_name: keyName,
          id_user: this.userData.id,
        })
        if (result.status >= 400) {
          throw new Error(result.data?.error || 'Erro ao criar pasta no banco de dados')
        }

        this.$notify({
          title: 'Sucesso',
          message: 'Pasta criada com sucesso.',
          type: 'success',
        })

        this.pastaAws.folder_name = ''
        this.listar()
        this.$emit('pasta-criada')
        this.$nextTick(() => {
          if (this.$refs['my-modal']) this.$refs['my-modal'].hide()
        })
      } catch (error) {
        this.$notify.error({
          title: 'Erro',
          message: `Não foi possível criar a pasta: ${error.message || error}`,
        })
      }
    },
    // handleSubmit (){
    //   fetch('http://localhost:3030/folder', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    //     body: '{"folder_name":"' + this.folder.folder_name +
    //     '","id_user":"' + this.userData.id + '"}'

    //   })
    //   .then(response => {
    //     window.location.replace("http://localhost:8080/videos");
    //   })

    //     .catch(err => console.error(err));
    //   // Exit when the form isn't valid
    //   if (!this.checkFormValidity()) {
    //     return
    //   }

    //   // Push the name to submitted names
    //   this.folders.push(this.folder)
    //   // Hide the modal manually
    //   this.$nextTick(() => {
    //     this.$refs['my-modal'].toggle('#toggle-btn')
    //   })
    // },
  },
}
</script>

<style>
#modal-prevent-closing .modal-content {
  background: #111827 !important;
  border: 1px solid rgba(255,255,255,0.1) !important;
  color: #e2e8f0 !important;
}
#modal-prevent-closing .modal-header {
  background: #0D3349 !important;
  border-bottom: 1px solid rgba(255,255,255,0.1) !important;
}
#modal-prevent-closing .modal-title {
  color: #fff !important;
}
#modal-prevent-closing .modal-header .close {
  color: rgba(255,255,255,0.6) !important;
}
#modal-prevent-closing .modal-body {
  background: #111827 !important;
}
#modal-prevent-closing .modal-footer {
  background: #111827 !important;
  border-top: 1px solid rgba(255,255,255,0.08) !important;
}
#modal-prevent-closing label {
  color: #94a3b8 !important;
}
#modal-prevent-closing input.form-control {
  background: rgba(255,255,255,0.06) !important;
  border: 1px solid rgba(255,255,255,0.12) !important;
  color: #e2e8f0 !important;
}
#modal-prevent-closing input.form-control::placeholder {
  color: #64748b !important;
}
#modal-prevent-closing input.form-control:focus {
  background: rgba(255,255,255,0.09) !important;
  border-color: #E86A10 !important;
  box-shadow: 0 0 0 2px rgba(232,106,16,0.15) !important;
}
#modal-prevent-closing .btn-secondary,
#modal-prevent-closing footer .btn:not(.btn-primary) {
  background: rgba(255,255,255,0.08) !important;
  border-color: rgba(255,255,255,0.15) !important;
  color: #94a3b8 !important;
}
#modal-prevent-closing .btn-primary {
  background: linear-gradient(135deg, #E86A10, #f08535) !important;
  border-color: transparent !important;
  color: #fff !important;
}
</style>
